export const pageStates = {
  verified: "verified",
  registrationSuccess: "registrationSuccess",
  alreadyRegistred: "alreadyRegistred",
  registrationTimeout: "registrationTimeout",
  transactionExpired: "transactionExpired",
  transactionCancelled: "transactionCancelled",
  wrongRegistrationUrl: "wrongRegistrationUrl",
  processCanceled: "processCanceled",
  unknownError: "unknownError",
  deviceRegistrationFailure: "deviceRegistrationFailure",
}